import { Result, TrimValidationFields, backendApi } from "./backendApi";

export interface GlossaryTextExceptionModel {
  text?: string;
}

class GetGlossaryTextExceptionsRequest {}

class GetGlossaryTextExceptionsResponse {
  glossaryTextExceptions?: GlossaryTextExceptionModel[];
}

class CreateGlossaryTextExceptionRequest {
  GlossaryTextExceptionModel?: GlossaryTextExceptionModel;
}

class updateGlossaryTextExceptionRequest {
  text?: string;
  glossaryTextExceptionModel?: GlossaryTextExceptionModel;
}

class deleteGlossaryTextExceptionRequest {
  text?: string;
}

export const glossaryTextExceptionApi = {
  async getGlossaryTextExceptions(): Promise<
    Result<GlossaryTextExceptionModel[]>
  > {
    let response =
      await backendApi.sendAndGetResponseAsync<GetGlossaryTextExceptionsResponse>(
        "GetGlossaryTextExceptions",
        {} as GetGlossaryTextExceptionsRequest,
      );

    if (response.ok) {
      return { ok: true, value: response.value.glossaryTextExceptions ?? [] };
    }

    return response;
  },

  async createGlossaryTextException(
    GlossaryTextExceptionModel: GlossaryTextExceptionModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("CreateGlossaryTextException", {
      GlossaryTextExceptionModel: GlossaryTextExceptionModel,
    } as CreateGlossaryTextExceptionRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "GlossaryTextExceptionModel");

    return response;
  },

  async updateGlossaryTextException(
    text?: string,
    glossaryTextExceptionModel?: GlossaryTextExceptionModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateGlossaryTextException", {
      text: text,
      glossaryTextExceptionModel: glossaryTextExceptionModel,
    } as updateGlossaryTextExceptionRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "GlossaryTextExceptionModel");

    return response;
  },

  async deleteGlossaryTextException(text?: string): Promise<Result<any>> {
    let response = await backendApi.sendAsync("DeleteGlossaryTextException", {
      text: text,
    } as deleteGlossaryTextExceptionRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    return response;
  },
};
